/**
 * DevToolsFab 노출 조건.
 *
 * NODE_ENV는 build:dev에서도 'production'이므로 ENVIRONMENT 기준으로 판별.
 */
export const IS_DEV_ENV = process.env.ENVIRONMENT === 'development';
